'use client'

import { createClient } from '@/utils/supabase/client'

export default function LoginButton() {
    const supabase = createClient()

    const handleLogin = async () => {
        await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: `${location.origin}/auth/callback`,
            },
        })
    }

    return (
        <button
            onClick={handleLogin}
            className="bg-foreground text-background rounded-md px-4 py-2 hover:bg-[#383838] hover:text-white transition-colors flex items-center justify-center gap-2"
        >
            Sign in with Google
        </button>
    )
}
